import * as React from "react";
import { forwardRef } from "react";
const SvgAltArrowDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10.3086 13.196L15.6667 7.67058C16.001 7.3258 15.7984 6.66669 15.358 6.66669H4.64188C4.20153 6.66669 3.99887 7.3258 4.33321 7.67058L9.69129 13.196C9.86891 13.3791 10.131 13.3791 10.3086 13.196Z", fill: "#1C274C" }));
const ForwardRef = forwardRef(SvgAltArrowDown);
export { ForwardRef as ReactComponent };
